import type { TFunction } from "i18next";
import { z } from "zod";

export const REVIEW_RESOLUTION_DOCUMENT_FIELD = "reviewResolutionDocuments" as const;
export const REVIEW_RESOLUTION_DOCUMENT_CERTIFICATE_TYPE = "RESOLVE_DISPUTE_DOCUMENT";
export const REVIEW_RESOLUTION_DETAILS_MAX_LENGTH = 2000;
export const REVIEW_RESOLUTION_DOCUMENTS_MAX_FILES = 5;

const reviewResolutionDocumentSchema = z.object({
  originalFileName: z.string(),
  url: z.string(),
});

export const getReviewResolutionDrawerSchema = (t: TFunction, mode: "accept" | "reject") =>
  z.object({
    details:
      mode === "reject"
        ? z
            .string()
            .trim()
            .min(
              1,
              t("form-validation.required", {
                label: t("vessel-call.operations.rejection-reason"),
              }),
            )
            .max(
              REVIEW_RESOLUTION_DETAILS_MAX_LENGTH,
              t("form-validation.max-length", {
                label: t("vessel-call.operations.rejection-reason"),
                max: REVIEW_RESOLUTION_DETAILS_MAX_LENGTH,
              }),
            )
        : z
            .string()
            .trim()
            .max(
              REVIEW_RESOLUTION_DETAILS_MAX_LENGTH,
              t("form-validation.max-length", {
                label: t("vessel-call.operations.comments"),
                max: REVIEW_RESOLUTION_DETAILS_MAX_LENGTH,
              }),
            ),
    [REVIEW_RESOLUTION_DOCUMENT_FIELD]: z
      .array(reviewResolutionDocumentSchema)
      .max(
        REVIEW_RESOLUTION_DOCUMENTS_MAX_FILES,
        t("form-validation.max-files", { max: REVIEW_RESOLUTION_DOCUMENTS_MAX_FILES }),
      )
      .optional(),
  });
